import React, { useMemo, useState } from "react";
import { Container } from "react-bootstrap";
import styles from "./styles/styles.module.scss";
import Link from "next/link";
import Image from "next/future/image";

import { useRouter } from "next/router";
import { FormattedMessage } from "react-intl";

import { CiMenuFries } from "react-icons/ci";
import MobileMenu from "./MobileMenu";
import { useSelector } from "react-redux";
import { handleImageLink } from "@/helpers/functions";

const Index = ({ innerPages, landing, thanksHeader }) => {
  const { asPath, locale, pathname, query } = useRouter();
  const [showSidebar, setShowSidebar] = useState(false);

  const { settings, singleBlog, singleCategory } = useSelector(
    (state) => state.settings,
  );

  const targetLocale = locale === "en" ? "ar" : "en";

  const localizedPath = useMemo(() => {
    const cleanPath = (asPath || "/").split("?")[0].split("#")[0] || "/";

    if (pathname === "/blog/[slug]") {
      const blogSlug = singleBlog?.slug?.[targetLocale];
      if (typeof blogSlug === "string" && blogSlug.length > 0) {
        return `/blog/${blogSlug}`;
      }

      if (typeof query?.slug === "string" && query.slug.length > 0) {
        return `/blog/${query.slug}`;
      }

      return "/blog";
    }

    if (pathname === "/blog/categories/[slug]") {
      const categorySlug = singleCategory?.slug?.[targetLocale];
      if (typeof categorySlug === "string" && categorySlug.length > 0) {
        return `/blog/categories/${categorySlug}`;
      }

      if (typeof query?.slug === "string" && query.slug.length > 0) {
        return `/blog/categories/${query.slug}`;
      }

      return "/blog/categories";
    }

    if (cleanPath.includes("[slug]") || cleanPath.includes("%5Bslug%5D")) {
      return "/blog";
    }

    return cleanPath;
  }, [asPath, pathname, query?.slug, singleBlog, singleCategory, targetLocale]);

  return (
    <div
      className={
        landing
          ? `${styles["header-section"]} ${styles["landing-page"]}`
          : thanksHeader
            ? `${styles["header-section"]} ${styles["thanks-page"]}`
            : `${styles["header-section"]}`
      }
    >
      <Container className="d-flex align-items-center gap-3 justify-content-between">
        <div className="logo">
          <Link href="/" prefetch={false}>
            <a>
              <Image
                src={
                  locale === "ar"
                    ? handleImageLink(settings?.appLogo)
                    : handleImageLink(settings?.appLogoEn)
                }
                width={140}
                height={50}
                alt="Logo"
                title={settings?.appName || ""}
              />
            </a>
          </Link>
        </div>

        {!landing && (
          <div className="menu">
            <ul className="d-flex align-items-center gap-4">
              <li>
                <Link href="/" prefetch={false}>
                  <a className={asPath === "/" ? "active" : ""}>
                    <FormattedMessage id="home" />
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/about" prefetch={false}>
                  <a className={asPath === "/about" ? "active" : ""}>
                    <FormattedMessage id="about-us" />
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/services" prefetch={false}>
                  <a className={asPath.includes("services") ? "active" : ""}>
                    <FormattedMessage id="services" />
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/projects" prefetch={false}>
                  <a className={asPath.includes("projects") ? "active" : ""}>
                    <FormattedMessage id="projects" />
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/blog" prefetch={false}>
                  <a className={asPath.includes("blog") ? "active" : ""}>
                    <FormattedMessage id="blog" />
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/faqs" prefetch={false}>
                  <a className={asPath === "/faqs" ? "active" : ""}>
                    <FormattedMessage id="faqs" />
                  </a>
                </Link>
              </li>
            </ul>
          </div>
        )}

        <div className="actions d-flex align-items-center gap-3">
          <Link
            href={localizedPath}
            locale={targetLocale}
            passHref
            prefetch={false}
          >
            <a className="lang">{locale === "en" ? "AR" : "EN"}</a>
          </Link>
          <Link href="/contact" prefetch={false}>
            <a className={`btn ${innerPages ? "inner-btn" : ""}`}>
              <FormattedMessage id="request" />
            </a>
          </Link>
          <button
            type="button"
            className="menu-btn d-lg-none"
            aria-label="Toggle Menu"
            onClick={() => setShowSidebar(true)}
          >
            <CiMenuFries size={30} color="#fff" />
          </button>
        </div>
      </Container>

      <MobileMenu showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
    </div>
  );
};

export default Index;
